const formatTimeDuration = (time: number) => {
  const hours = Math.floor(time / 3600);
  const minutes = Math.floor((time - hours * 3600) / 60);
  const seconds = time - hours * 3600 - minutes * 60;

  return [hours, minutes, seconds].map(number => String(number).padStart(2, '0')).join(':');
};

export { formatTimeDuration };
